import { Message } from 'element-ui';  
export default {
    //输入框为数字
    must_number_s(e,maxlength,label) {
        if(label!='pH'){
            var val = e;
            e.target.value = e.target.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
            e.target.value = e.target.value.replace(/^\./g,"");  //验证第一个字符是数字而不是.
            e.target.value = e.target.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的.
            e.target.value = e.target.value.replace(/^[0-9]{10,}([.][0-9]{3,})?$/,e.target.value.slice(0,e.target.value.length-3));  //只能输入七位正整数
            // e.target.value = e.target.value.slice(0,7);
            // e.target.value = e.target.value.replace(/^\+?(\d*\.\d{3,})$/,e.target.value.slice(0,e.target.value.length-3)); //只能输入俩位小数
            e.target.value = e.target.value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");

        }
        return e.target.value
    },
    //调整限值输入框为PH格式
    checkPH(e,ph){
        if(ph=='pH'){
            if(e.target.value.indexOf('-')==-1){
                Message.error('请输入正确的格式，如6-9');
                e.target.value = '6-9'
            }
        }
        return e.target.value
    },
    //调整限值表头红色星号
    must(obj) {
        if(obj.columnIndex == 2) {
            return 'must';
        }
    },
    // getCurrentTime(){
    //     return new Date().Format("yyyy-MM-dd hh:mm:ss"); 
    // }
    getCurrentTime() { // author: meizz
        var date = new Date();
        var seperator1 = "-";
        var seperator2 = ":";
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hours >= 0 && hours <= 9) {
            hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        var currentdate = date.getFullYear() + seperator1 + month + seperator1 + day + " " + hours + seperator2 + minutes + seperator2 + seconds;
        return currentdate;
    },
    // 获取地址栏url的get参数，传递参数名进来就能返回
    getQueryString(url = "", name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var cc = url.split("?");
        if (cc.length < 2) return "";
        cc[1] = "?" + cc[1];
        var r = cc[1].substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/utils/publicMethod.js